module.exports = require("@swa-ui/core/src/CheckButton/CheckButton.module.scss");